// FIXME Delete, it is used only for 'savings'
export const QuestionConstants = {
	performerGroup: 'performer',
	savingsGroup: 'savings',
	insuranceGroup: 'prescription_insurance',
};